export default "__VITE_ASSET__CP7P07BQ__"